import {
  HTTP
} from "@/http";

export default class AccountService {
  getSummary(mt4Account) {
    return HTTP.get(
      `mt4/` +
      mt4Account.accountType.mT4Server.mT4ServerId +
      `/summary/` +
      mt4Account.login
    );
  }

  getPendingAccountTypesToCreate(accountId) {
    return HTTP.get(`accounts/types/pendings/` + accountId);
  }

  setDefaultMt4Account(mt4Account) {
    return HTTP.post(`accounts/mt4/` + mt4Account.accountType.accountTypeId + `/default`);
  }

  getDefaultMt4Account() {
    return HTTP.get(`accounts/mt4/default`);
  }

  createMT4LiveAccount() {
    return HTTP.post(`accounts/mt4`);
  }

  getMT4Accounts() {
    return HTTP.get(`accounts/mt4`);
  }
}



// WEBPACK FOOTER //
// ./src/services/AccountService.js